import $ from 'jquery';

class Toggles  {

	constructor() {
		this.toggleParent = $(".mtoggle li.active");
		this.events();
	}

	events() {
    this.toggleParent.on("click", this.toggleInit.bind(this));
    $(document).on("keydown", this.keyPressDispatcher.bind(this));
    $(window).on("click", this.closeOptionPanel.bind(this));
	}

	toggleInit(e) {
    if ($(this)) {
    	e.stopPropagation();
      let target, slug = e.target;
      let currentEle = e.currentTarget;
      let mElement = currentEle.getAttribute("data-target");
      let hold = $("span", currentEle).attr("data-hold");
      target = slug.getAttribute('data-text');

      $("ul[data-pane!="+mElement+"]").removeClass('inView');
      $("ul[data-pane="+mElement+"]").toggleClass('inView');

      if(target) {
        $("span", currentEle).html(target);

        $(".mtoggle").each( (int, value) => {
          let spanNode = this.toggleParent[int].childNodes[0];
          let filterType = this.toggleParent[int].getAttribute("data-target");
          let reset = this.toggleParent[int].childNodes[0].getAttribute("data-hold");
          if(filterType !== mElement) {
            spanNode.innerHTML =reset;
          }
        });
        $(".filter-text").val("");

      } else {
        $("span", currentEle).html(hold);
        $(".mtoggle").each( (int, value) => {
          let spanNode = this.toggleParent[int].childNodes[0];
          let filterType = this.toggleParent[int].getAttribute("data-target");
          let reset = this.toggleParent[int].childNodes[0].getAttribute("data-hold");
          if(filterType !== mElement) {
            spanNode.innerHTML =reset;
          }
        });
        $(".filter-text").val("");
      }

    }
	}

	closeOptionPanel(e) {
    if ($(this)) {
      if (this.toggleParent.has(e.target).length == 0 && !this.toggleParent.is(e.target)) {
        $("ul", this.toggleParent).removeClass('inView');
      }
    }
	}

  keyPressDispatcher(e) {
    if ($(this) && e.keyCode == 27) {
      $("ul", this.toggleParent).removeClass('inView');
    }
  }

}

export default Toggles;